module.exports = __webpack_public_path__ + "static/img/icon-docMoney.aa0059ba.png";